import angular from 'angular';
import MessagesWidgetComponent from './messages-widget-component';

export default angular.module('messages-widget', []).component('messagesWidget', new MessagesWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/messages/messages-widget-module.js